const RESOURCE_NAME = '/user-favorites';
import restApi from "@/api/rest-api-object";
export default axios => ({
    ...restApi(axios, RESOURCE_NAME),
    create(data, params) {
        console.error('action Create not working',data, params)
    },
    update(id, type, data, params) {
        return axios.put(`${RESOURCE_NAME}/${type}/${id}`, data, {params});
    },
    delete(id, type, params) {
        return axios.delete(`${RESOURCE_NAME}/${type}/${id}`, {params});
    },
});